export const solidColors = [
  'rgb(114,147,203)',
  'rgb(225,151,76)',
  'rgb(132,186,91)',
  'rgb(211,94,96)',
  'rgb(128,133,133)',
  'rgb(144,103,167)',
  'rgb(171,104,87)',
  'rgb(204,194,16)',
];

export const lineColors = [
  'rgb(57,106,177)',
  'rgb(218,124,48)',
  'rgb(62,150,81)',
  'rgb(204,37,41)',
  'rgb(83,81,84)',
  'rgb(107,76,154)',
  'rgb(146,36,40)',
  'rgb(148,139,61)',
];

export const flatColors = [
  'rgb(26, 188, 156)',
  'rgb(22, 160, 133)',
  'rgb(46, 204, 113)',
  'rgb(39, 174, 96)',
  'rgb(52, 152, 219)',
  'rgb(41, 128, 185)',
  'rgb(155, 89, 182)',
  'rgb(142, 68, 173)',
  'rgb(52, 73, 94)',
  'rgb(44, 62, 80)',
  'rgb(241, 196, 15)',
  'rgb(243, 156, 18)',
  'rgb(230, 126, 34)',
  'rgb(211, 84, 0)',
  'rgb(231, 76, 60)',
  'rgb(192, 57, 43)',
  'rgb(236, 240, 241)',
  'rgb(189, 195, 199)',
  'rgb(149, 165, 166)',
  'rgb(127, 140, 141)',
];



// WEBPACK FOOTER //
// ./src/config/chartColors.js